import { gql } from '@apollo/client';

export const ChangeAgentVoice = gql`
    mutation changeAgentVoice($voiceId: Int!, $agentId: ID!) {
        changeAgentVoice(voiceId: $voiceId, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
